import { render } from "./App.vue?vue&type=template&id=4ad930f5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4ad930f5&lang=scss"
import "@/assets/id-sk-frontend/idsk-frontend.min.css?vue&type=style&index=1&lang=css"
script.render = render

export default script